var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "frame",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.53 168.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.96,
    y: 88.21,
    width: 20.26,
    height: 20.26,
    fill: "#8cebff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.31,
    y: 88.21,
    width: 20.26,
    height: 20.26,
    fill: "#e6ff8c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.96,
    y: 59.86,
    width: 20.26,
    height: 20.26,
    fill: "#c28cff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLeft);
export default __webpack_public_path__ + "static/media/square-left.6b940886eeddb5900e360418a633f86a.svg";
export { ForwardRef as ReactComponent };